import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';

let options = {};
let headers = new Headers();
let token = sessionStorage.getItem("token");

headers.append('content-type', 'application/json');
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function getVersionNumbering() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/version/getdealerversion`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function addNewVersion(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/version/dealerversioninsertupdate`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function getVersionContainData(bool) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/version/getdealerversiondetails`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function addVersionFormData(data) {
    try {
        const headers = new Headers();
        headers.append('Authorization', `${token}`);

        const response = await fetch(`${BASE_URL_M_ADMIN}madmin/version/dealerversiondetailsinsertupdate`, {
            method: 'POST',
            headers,
            body: data,
        });
        const res = await response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function uploadFileWithData(data) {
    // try {
    //     const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/version/uploadversionfile`, data, options);
    //     const res = response.json();
    //     return res;
    // } catch (error) {
    //     return error
    // }
    try {
        const headers = new Headers();
        headers.append('Authorization', `${token}`);

        const response = await fetch(`${BASE_URL_M_ADMIN}madmin/version/uploadversionfile`, {
            method: 'POST',
            headers,
            body: data,
        });

        const res = await response.json();
        return res;
    } catch (error) {
        return error
    }
}